import { MemoryRouter } from 'react-router-dom';
import { renderApp } from './utils/utils';
import { QueryClientProvider } from '@tanstack/react-query';
import { client } from '../../../components/rest/react-query';
import { Cancel, navigationOrder } from '@hungryroot/pages-cancel';

function CancelFlow() {
  return (
    <QueryClientProvider client={client}>
      <MemoryRouter initialEntries={navigationOrder} initialIndex={0}>
        <Cancel testid="cancel" />
      </MemoryRouter>
    </QueryClientProvider>
  );
}

renderApp(<CancelFlow />, 'cancel-react-component');
